export const sendEvent = (category, action, label, custom) => {
    try {
        if (window.gtag || []) {
            let eventData = {
                event_category: category,
                event_label: label
            };
            if (custom) {
                Object.keys(custom).forEach((key) => {
                    eventData[key] = custom[key];
                });
            }
            window.gtag("event", action, eventData);
        }
    } catch (e) { console.log(e); }
};